import React from "react"
import { AuthenticationLayout } from "layoutsV2/client/AuthenticationLayout"
import { SignUp as SignUpForm } from "ui/auth/SignUp"

export const SignUp = () => (
  <AuthenticationLayout type="signup">
    <SignUpForm />
  </AuthenticationLayout>
)
